import React from 'react';
import { Link } from 'react-router-dom';
import { CLOUDFRONT_URL } from '../../../core/common';

type AlbumCardType = {
  album: {
    id: number;
    title: string | null;
    photos: Array<{
      id: number;
      filename: string;
      public_path: string;
      created_at: string;
    }>;
  };
};

function AlbumCard({ album }: AlbumCardType) {
  const firstPhoto = album.photos && album.photos.length > 0 ? album.photos[0] : null;
  const photoCount = album.photos ? album.photos.length : 0;

  return (
    <div className="album-card">
      <Link to={`/photos/${album.id}`} className="album-card-link">
        <div className="album-card-image-wrapper">
          {firstPhoto ? (
            <img
              src={`${CLOUDFRONT_URL}${firstPhoto.public_path}`}
              alt={firstPhoto.filename}
              className="album-card-image"
            />
          ) : (
            <div className="album-card-image-placeholder" />
          )}
          <div className="album-card-photo-count">
            <i className="fa fa-image album-card-photo-count-icon" />
            <span className="album-card-photo-count-number">{photoCount}</span>
          </div>
        </div>
        {album.title && (
          <div className="album-card-title-overlay">
            <span className="album-card-title">{album.title}</span>
          </div>
        )}
      </Link>
    </div>
  );
}

export default AlbumCard;
